import { Box, Container, Typography } from "@mui/material";
import TablaUsuariosV2 from "@/components/Tablas/TablaUsuariosV2";
import useTablaUsuarios from "@/components/Tablas/TablaUsuariosV2/useTablaUsuarios";
import { useEffect } from "react";
import PageTitleWrapper from "../../../components/PageTitleWrapper";


const UsuariosPage = () => {


    const useTable = useTablaUsuarios()

    useEffect(() => {
        useTable.getUsuarios()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])





    return (<>
        <PageTitleWrapper>
            <Typography component='h3' sx={{
                margin: '0px 0px 4px',
                fontWeight: 700,
                fontSize: '25px',
                lineHeight: 1.4,
            }} >
                Usuarios
            </Typography>
            <Typography component='p' sx={{
                margin: '0px',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: 1.4,
                color: '#6b778c',
            }} >
                Gestioná todos los usuarios desde esta sección
            </Typography>
        </PageTitleWrapper>
        <Box sx={{
            maxWidth: '1440px',
            margin: '0 auto',
        }}
        >
            <Container>
                <TablaUsuariosV2 hook={useTable} />
            </Container>
        </Box>

    </>);
}

export default UsuariosPage;